import { useParams } from "react-router-dom";
import { TableDisplay } from "../components/TableDisplay";
import CatalogV2 from "./CatalogV2";
import MarkdownBlock from "../components/MarkdownBlock";
import { useEffect } from "react";
import { track } from "../tracking";

const ExploreTables = ({
  publicVisible
}: {
  publicVisible?: boolean
}) => {

  const params = useParams()
  
  useEffect(() => {
    track('Page View: Public Tables', {})
  }, [])


  return <div className="flex v2 bg-[#fff]">
    <div className="border-r w-[300px]">
      <CatalogV2 viewMode publicVisible={publicVisible} />
    </div>
    <div className="">
      {
        params.tableId ? <TableDisplay publicVisible={publicVisible} isEditMode={false} onUpdate={() => { }} /> : <div className="bg-[#fff] text-gray-500 p-[50px] w-[960px] min-w-[960px]">
          <MarkdownBlock
            isEditMode={false}
            value={`# Data Catalog

ZettaBlock provides a wide range of blockchain tables across EVM and non-EVM ecosystems for both indexing and analytics purposes. 
For detailed information on ZettaBlock's data models, please visit our [Data Catalog](https://docs.zettablock.com/page/data-catalog).

## Tables Supported

Here is an overview the tables available on ZettaBlock at different levels of abstraction.

| Data Type       | Description                                                                                    |
|:----------------|:-----------------------------------------------------------------------------------------------|
| Raw             | Blocks, transactions, logs and traces tables, with decoded info saved in same table.           |
| Decoded         | ERC20, nft_tokens and other decoded event tables.                                              |
| Transfers       | ERC20, ERC721 and ERC1155 transfer data.                                                       |
| Balances        | Wallet's ERC20, ERC721 and ERC1155 tokens latest balance or real time balance data.            |
| DEX             | DEX protocol related abstraction tables, such as pools, swaps tables.                          |
| NFT             | NFT related abstraction tables.                                                                |
| Misc            | Other abstraction tables such as ENS and labels.                                               |

# Chains Supported

We support the following chains in data lake and realtime (with ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg)) across multiple data types. More chains and types are being onboarded and will coming soon.

We support the following chains in data lake and realtime. More chains are being onboarded and will coming soon.

| Type        | Chain                 | Raw &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; | Decoded | Transfers | Balances | DEX &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; | NFT &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; | Misc &nbsp; &nbsp; &nbsp; &nbsp; |
|:------------|:----------------------|:--------------|:--------------|:--------------|:--------------|:--------------|:--------------|:--------------|
| EVM         | Ethereum              | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg)  | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg)  | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg)  | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg)  | ✅            | ✅             | ✅            |
|             | zkSync                | ✅            | ✅             | ✅            |               | ✅            |               |               | 
|             | Polygon zkEVM         | ✅            | ✅             | ✅            |               |               |               |               |
| Non-EVM     | Solana                | ✅            | ✅             | ✅            | ✅            |               |                | ✅            | 
|             | Sui                   | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg)  | ✅             |               | ✅            | ✅            | ✅             |              | 
|             | Beacon                | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg) |               |               |               |               |               |               |
|             | Beacon Holesky       | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg) |               |               |               |               |               |               |
|             | Stellar              | ✅ ![realtime_icon](https://app.zettablock.com/assets/icons/toggle.svg) |               |               |               |               |               |               |

## Data Status and Freshness

For detailed table status and freshness in each chain, please check out the Status page (coming soon).

## Appendix

For those interested, the diagram below showcases **a high-level overview of ZettaBlock's approach to creating tables from raw blockchain data**. 

As shown below, the hierarchy is split into 3 levels of tables - bronze, silver and gold. Bronze tables are derived from raw on-chain data that is then combined with decoded on-chain data and funneled to create the silver layer of tables. Through further data modeling, the abstraction or gold level of tables will be eventually created.

![image](https://files.readme.io/729ae3d-schema-Top_Level_View.drawio.png)`}

            // # Table Availability, Status And Freshness

            // For detailed tables available in each chain, please check our [Data Catalog](https://app.zettablock.com/v2/explore/tables) page. 
            // Please refer to the [Status](https://app.zettablock.com/v2/freshness) page for table status and freshness.   
            onChange={() => { }}
          />

        </div>
      }

    </div>

  </div>
}

export default ExploreTables;